export default __webpack_public_path__ + "static/media/Michael-Finkelstein.983646ad.png";